'use strict';

const { h, Component } = require('phy');

const Header = require('../../shared/views/header');
const MainTitle = require('../../coupons/views/main-title');
const CategoryLinks = require('./category-links');
const CtaTopOffers = require('../../coupons/views/cta-top-offers');
const MerchantLinks = require('../../merchant/views/merchant-links');
const Breadcrumbs = require('../../../components/breadcrumbs');

class Categories extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);
    this.state = { divisionId: props.initialDivisionId };
  }

  render({ payload, deps }) {
    const {
      keyAuthData,
      seoMetaData: { h1Override },
      categoryData,
      navigationMerchants,
      popularMerchants,
    } = payload;
    const { routes, breadcrumbList } = deps;

    return h('article', [
      h(Header, {
        routes,
        activePage: 'categories',
        keyAuthData,
        merchants: navigationMerchants,
      }),
      h('section.container', [
        Breadcrumbs(breadcrumbList),
        h(MainTitle, {
          h1Override,
          resourceKey: 'modules.category.PageHeading',
        }),
        h(CategoryLinks, { routes, keyAuthData, categoryData }),
        h(CtaTopOffers, { routes }),
        h(MerchantLinks, { routes, merchants: popularMerchants }),
      ]),
    ]);
  }
}

module.exports = Categories;
